<template>
  <div>
    <ul
      id="m_quick_sidebar_tabs"
      class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
      role="tablist"
    >
      <li class="nav-item m-tabs__item">
        <a class="nav-link m-tabs__link active" data-toggle="tab" href="#save_segment" role="tab">
          <h4>Gerar fatura avulsa</h4>
        </a>
      </li>
    </ul>
    <form name="company" class="needs-validation" novalidate>
      <div
        id="alert"
        class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
        :class="alert.color"
        role="alert"
        v-if="alert.message"
        ref="alert"
      >
        <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
        <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
        ><br />
        {{ alert.reason }}
      </div>
      <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
        <h5><i class="fas fa-pen-nib"></i> Informações da fatura</h5>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-group">
            <label for="customer_id">Cliente <span class="m--font-danger">*</span></label>
            <div class="input-group">
              <div class="input-group">
                <SelectCustomers
                  id="customer_id"
                  ref="customer_id"
                  :first="'Selecione um cliente'"
                  :selected="data.customer_id"
                  @change="data.customer_id = $event"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="prod_id">Produto <span class="m--font-danger">*</span></label>
            <div class="input-group">
              <div class="input-group">
                <SelectProducts
                  id="prod_id"
                  ref="prod_id"
                  :first="'Selecione um produto'"
                  :selected="data.prod_id"
                  @change="updateProductIdValue"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="billing_month">Referente ao mês</label>
            <div class="input-group">
              <InputBillingMonth ref="billing_month" v-model="data.billing_month" />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="due_date">Vencimento</label>
            <div class="input-group">
              <input
                id="due_date"
                ref="due_date"
                type="date"
                name="due_date"
                class="form-control m-input"
                v-model="data.due_date"
              />
            </div>
          </div>
        </div>
            <div class="col-md-1 mt-3">
              <label>Cancelamento</label>
              <div class="input-group">
                <span class="m-switch m-switch--icon" title="Fatura de cancelamento de contrato">
                  <label>
                    <input
                      type="checkbox"
                      @change="!data.cancellation"
                      name="international"
                      v-model="data.cancellation"
                    />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
      </div>
      <div class="alert m-alert m-alert--default col-md-12 mb-12 mt-5" role="alert">
        <h5><i class="fas fa-tags"></i> Modelos de negócios e valores</h5>
      </div>
      <div class="row" v-for="(dt, index) in data.details" :key="index">
        <div class="col-md-6">
          <div class="form-group">
            <label>Modelo de negócio</label>
            <div class="input-group">
              <SelectUniqueInvoice
                :selects="selects"
                :first="'Selecione um modelo de negócio'"
                v-model="dt.detail_id"
                :selectedId="dt.detail_id"
                @change="updateDetailValue($event, index)"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Valor</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">R$</span>
              </div>
              <money
                v-bind="money"
                class="form-control m-input"
                @keyup.native="calcTotal()"
                v-model="dt.total"
              ></money>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-sm btn-metal m-btn m-btn--custom"
            @click="data.details.push(Object.assign({}, detail_default))"
          >
            <i class="fas fa-plus-circle"></i> Adicionar modelo
          </button>
        </div>
        <div class="col-md-3">
          <div class="form-group" :id="data.total">
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="col-md-12 form-control text-right custom-input-loose"
                value="Valor total:"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group" :id="data.total">
            <div class="input-group input-group-sm">
              <div class="input-group-prepend">
                <span class="input-group-text">R$</span>
              </div>
              <input
                type="text"
                class="form-control text-right"
                :value="data.total"
                placeholder="0,00"
                ui-number-mask
                disabled
              />
            </div>
          </div>
        </div>
      </div>
      <div class="alert m-alert m-alert--default mb-3 mt-5" role="alert">
        <h5><i class="fas fa-file-alt"></i> Observações</h5>
      </div>
      <div class="row mb-5">
        <div class="col-md-12">
          <div class="input-group">
            <textarea class="form-control" name="note" v-model="data.note"></textarea>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mb-2">
        <div class="col-md-12 text-right">
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.customer_id.$el.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!data.customer_id"
              >O campo <strong>Cliente</strong> é obrigatório *</a
            >
          </p>
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.prod_id.$el.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!this.selects"
              >O campo <strong>Produto</strong> é obrigatório *</a
            >
          </p>
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.billing_month.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!data.billing_month"
              >O campo <strong>Referente oa Mês</strong> é obrigatório *</a
            >
          </p>
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.due_date.$el.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!data.due_date"
              >O campo <strong>Data Vencto</strong> é obrigatório *</a
            >
          </p>
          <p class="p-0 m-0">
            <a
              href="#"
              target="_self"
              class="m--font-danger"
              v-if="!data.details[0] || (data.details[0] && data.details[0].detail_id === '')"
              >O campo <strong>Modelo de negócio</strong> é obrigatório *</a
            >
          </p>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-md-12 text-right">
          <button
            @click.prevent="saveForm()"
            class="btn"
            :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
            :disabled="!formIsValid"
          >
            <i class="fas fa-save" v-if="formIsValid"></i>
            <i class="fas fa-exclamation-triangle" v-else></i>
            Salvar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Money } from 'v-money';
import SelectCustomers from '@/components/forms/SelectCustomers';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectUniqueInvoice from '@/components/forms/SelectUniqueInvoice';
import InputBillingMonth from '@/components/forms/InputBillingMonth';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

const SETUP_NUMBER = 95;
const NUMBER_REPLACEMENT_FEE = 96;

export default {
  mixins: [returnMessageFormMixin],
  name: 'InvoiceLooseSave',
  components: {
    SelectCustomers,
    SelectProducts,
    SelectUniqueInvoice,
    InputBillingMonth,
    Money,
  },
  data() {
    this.detail_default = {
      detail_id: '',
      amount: 1,
      unit_price: null,
      total: 0,
    };

    this.data_default = {
      customer_id: '',
      prod_id: '',
      due_date: '',
      billing_month: '',
      total: '',
      details: [{ ...this.detail_default }],
    };

    return {
      data: { ...this.data_default },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      selects: '',
      detail_default: { ...this.detail_default },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    updateProductIdValue(prodId) {
      axios(`${baseApiUrl}/v1/detail/list?productId=${prodId}&isUnique=1`).then((res) => {
        this.data.prod_id = prodId;
        this.selects = res.data;
      });
    },
    updateDetailValue(detailId, index) {
      const id = parseInt(detailId);
      
      if (id === SETUP_NUMBER) {
        this.data.details[index].total = 1000;
      } else if (id === NUMBER_REPLACEMENT_FEE) {
        this.data.details[index].total = 100;
      }
      
      this.calcTotal();
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;

      const url = `${baseApiUrl}/v1/invoice/create`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.data = { ...this.data_default };
          this.data.details = [{ ...this.detail_default }];
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    calcTotal() {
      let price = 0;
      this.data.details.forEach((detail) => {
        price += detail.total;
      });
      this.data.total = parseFloat(price).toFixed(2);
    },
  },
  computed: {
    formIsValid() {
      if (
        this.data.customer_id &&
        this.selects &&
        this.data.due_date &&
        this.data.billing_month &&
        this.data.billing_month < this.data.due_date &&
        this.data.details[0] &&
        this.data.details[0].detail_id !== ''
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
.text-right {
  text-align: right !important;
}
.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 8px);
}
.custom-input-loose {
  width: 526px !important;
}
</style>
